import { BrowserModule } from '@angular/platform-browser';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Observable } from 'rxjs/Rx';
import { Audit } from '../audits/audit.model';
import { AuditService } from "../audits/audit.service";
import { SearchService } from '../shared/search.service';
import { UserService } from "../users/user.service";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
    private userAuthenticatedSubscription: any;
    private searchKeyUp = new Subject<string>();

    public searchText: string;
    public recentChanges: Audit[] = [];
    @Output() sidebarToggled: EventEmitter<any> = new EventEmitter();
    @Input() isMobileView: boolean;
    private userAddedSubscription: any;
    private userUpdatedSubscription: any;
    private userDeletedSubscription: any;
    private updateTimer: any;
    private updateTimerSubscription: any;

    constructor(
        private searchService: SearchService,
        private auditService: AuditService,
        private userService: UserService) {

      // debounce the search to be more efficent
      const observable = this.searchKeyUp
          .map(value => event)
          .debounceTime(300)
          .distinctUntilChanged()
          .flatMap((search) => {
            return Observable.of(search).delay(150);
          })
          .subscribe((data) => {
            this.onKeySearch(data);
          });
    }

    ngOnInit() {
        this.userAuthenticatedSubscription = this.userService.currentUserAuthenticated.subscribe(() => this.getAuditNotifications());

        this.userAddedSubscription = this.userService.userAdded
            .subscribe((user: any) => {
                this.getAuditNotifications();
            });

        this.userDeletedSubscription = this.userService.userDeleted
            .subscribe((userId: string) => {
                this.getAuditNotifications();
            });

        this.userUpdatedSubscription = this.userService.userUpdated
            .subscribe((user: any) => {
                this.getAuditNotifications();
            });

        // update notificatiosn every 60 seconds
        this.updateTimer = Observable.timer(60000, 60000);
        this.updateTimerSubscription = this.updateTimer.subscribe(t => this.getAuditNotifications());

    }

    ngOnDestroy() {
        if (this.userAuthenticatedSubscription) this.userAuthenticatedSubscription.unsubscribe();
        if (this.userAddedSubscription)
            this.userAddedSubscription.unsubscribe();
        if (this.userDeletedSubscription)
            this.userDeletedSubscription.unsubscribe();
        if (this.userUpdatedSubscription)
            this.userUpdatedSubscription.unsubscribe();
        if (this.updateTimerSubscription)
            this.updateTimerSubscription.unsubscribe();
    }

    onKeySearch(event: any) {
        if (this.searchText.length > 2)
            this.searchService.emitSearchEvent(this.searchText);

        if (this.searchText.length === 0)
            this.searchService.emitClearSearchEvent();
    }

    onClearSearch(event: any) {
        this.searchText = '';
        this.searchService.emitClearSearchEvent();
    }

    getAuditNotifications() {
        this.auditService.getRecentChanges()
            .then(result => {
                this.recentChanges = result;
            })
            .catch(error => {
                console.log(error);
            });
    }

    toggleSidebar() {
        this.sidebarToggled.emit();
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/header/header.component.ts